import { site } from "@/data/portfolioData";

export function Footer() {
  return (
    <footer className="relative z-[2] flex flex-wrap items-center justify-between gap-3 border-t-3 border-ink px-6 py-[26px] md:px-14">
      <span className="font-display text-[15px] text-ink">{site.brand}</span>
      <span className="text-sm text-muted2">{site.footer}</span>
    </footer>
  );
}
